module.exports = function() {
  return new Worker(__webpack_public_path__ + "fa7acb7d61f04e9974ce.worker.js");
};